import { render, staticRenderFns } from "./CommonPageOld.vue?vue&type=template&id=bd779ed6"
import script from "./CommonPageOld.vue?vue&type=script&lang=js"
export * from "./CommonPageOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports